// Contract for the Manage Assessments page (the app's landing page). Shared between
// the API (which builds the payload from the platform DB and returns it in display
// order) and the web app (which renders it as received). Fields that depend on
// scoring (score, estimated duration) are intentionally absent until scoring is
// available.
/**
 * Lifecycle status of an assessment instance; the values mirror the platform's
 * `organization_surveys.submission_status` column. `Submitted` derives only from a
 * recorded submission; completing every section does not change status. `InProgress`
 * derives from any saved answer or terms acceptance, whichever comes first; otherwise
 * `NotStarted` (presented as "Now Open").
 */
export var SubmissionStatus;
(function (SubmissionStatus) {
    SubmissionStatus["NotStarted"] = "not_started";
    SubmissionStatus["InProgress"] = "in_progress";
    SubmissionStatus["Submitted"] = "submitted";
})(SubmissionStatus || (SubmissionStatus = {}));
/** Every wire value, for JSON-schema `enum` lists and runtime validation. */
export const SUBMISSION_STATUSES = Object.values(SubmissionStatus);
/** Map a raw platform `submission_status` value to the enum; unknown/absent reads as not started. */
export function toSubmissionStatus(raw) {
    return SUBMISSION_STATUSES.includes(raw ?? '')
        ? raw
        : SubmissionStatus.NotStarted;
}
//# sourceMappingURL=assessment-list.js.map